<script lang="ts">
	// The Bosla admin (UC-20). Bosla's own staff only, in English, on a site of
	// its own at admin.<domain>. It shows the sign-in until the API says who is
	// signed in, then the shell.

	import Loading from '../components/Loading.svelte';
	import { watchBuild } from '../build.svelte';
	import { resolvedTheme, setSurface } from '../display.svelte';
	import { copy } from './copy';
	import { currentView, start } from './session.svelte';
	import Shell from './Shell.svelte';
	import SignIn from './SignIn.svelte';

	setSurface('admin');

	$effect(() => {
		document.documentElement.dataset.theme = resolvedTheme();
	});

	$effect(() => {
		void start();
	});

	// An admin left open learns of a newer bundle (INT-7) and loads it at its
	// next navigation (router.svelte.ts).
	$effect(() => watchBuild());

	const view = $derived(currentView());
</script>

{#if view.kind === 'loading'}
	<div class="wait">
		<Loading label={copy.loading} testId="admin-loading" />
	</div>
{:else if view.kind === 'signin'}
	<SignIn notice={view.notice} googleId={view.googleId} />
{:else}
	<Shell email={view.email} />
{/if}

<style>
	.wait {
		min-block-size: 100dvh;
		display: grid;
		place-items: center;
		background: var(--surface-page);
	}
</style>
